// converted-webm-videos (transitions, Fx previews) is private: raw S3 reads return 403.
// Its CDN serves the bucket root with the same keys (no bucket prefix in the path).
// Probed 2026-11-01: raw 403, CDN 206 with ACAO `*`.

// Rollout switch (raw URLs stay unchanged while off).
export const CONVERTED_WEBM_CDN_REWRITE = true;

const BUCKET = 'converted-webm-videos';
const CDN_HOST = 'd1qlugglvc8yr3.cloudfront.net';

/**
 * A raw S3 URL of converted-webm-videos (path-style, virtual-host or s3-<region>) on its
 * CDN with the same key; anything else unchanged.
 */
export function toConvertedWebmCdnUrl(url: string): string {
  if (!CONVERTED_WEBM_CDN_REWRITE || typeof url !== 'string' || !url.includes(BUCKET)) {
    return url;
  }
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch (e) {
    return url;
  }
  const host = parsed.hostname.toLowerCase();
  const prefix = `/${BUCKET}/`;
  let key = '';
  if (/^converted-webm-videos\.s3([.-][a-z0-9-]+)?\.amazonaws\.com$/.test(host)) {
    key = parsed.pathname.slice(1);
  } else if (
    /^s3([.-][a-z0-9-]+)?\.amazonaws\.com$/.test(host) &&
    parsed.pathname.startsWith(prefix)
  ) {
    key = parsed.pathname.slice(prefix.length);
  }
  if (!key) {
    return url;
  }
  // presigned S3 auth params would conflict with the CDN's own origin auth
  const query = parsed.search
    .slice(1)
    .split('&')
    .filter((param) => param && !/^x-amz-/i.test(param))
    .join('&');
  const search = query ? `?${query}` : '';
  // raw S3 reads `+` in a path as a space; `%20` reads as a space on the CDN too
  return `https://${CDN_HOST}/${key.replace(/\+/g, '%20')}${search}`;
}
